<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="`${item.date}`" subtitle="Bookings and register.">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <!-- Data. -->
        <ui-data-grid>
            <ui-data-grid-section v-if="item.bookings.length"
                                  subtitle="Operatives that were booked in prior to this date."
                                  title="Bookings">
                <ui-data-grid-item wide>
                    <operative-planning-operative-booking-list>
                        <operative-planning-operative-booking-card
                            :key="`booking-operative-${item.date}-${booking.id}-${booking.was_present}-${booking.was_absent}`"
                            :can-confirm-presence="item.canConfirmPresence()"
                            v-for="booking in item.bookings"
                            :operative="booking"
                            :item="item"
                        >
                        </operative-planning-operative-booking-card>
                    </operative-planning-operative-booking-list>
                </ui-data-grid-item>
            </ui-data-grid-section>

            <ui-data-grid-section v-if="allRegisterOperatives.length"
                                  subtitle="Operatives that were booked on this date or after the date."
                                  title="Register">
                <ui-data-grid-item wide>
                    <operative-planning-operative-booking-list>
                        <operative-planning-operative-booking-card
                            :key="`register-operative-${item.date}-${operative.id}-${operative.was_present}-${operative.was_absent}`"
                            :can-confirm-presence="item.canConfirmPresence()"
                            v-for="operative in allRegisterOperatives"
                            :operative="operative"
                            :item="item"
                        >
                        </operative-planning-operative-booking-card>
                    </operative-planning-operative-booking-list>
                </ui-data-grid-item>
            </ui-data-grid-section>
        </ui-data-grid>
        <ui-data-grid-item label="Quick action" wide v-if="item.bookings.length">
            <div class="flex flex-col md:flex-row flex-wrap -m-2">
                <ui-button-new class="m-2" icon="fas fa-route" @click="duplicateItem" success>Duplicate Bookings
                </ui-button-new>
            </div>
        </ui-data-grid-item>

        <ui-data-grid>
            <ui-data-grid-item label="Created By">{{ item.created_by.name }} on {{
                    item.created_at
                }}
            </ui-data-grid-item>
            <ui-data-grid-item label="Last Updated By">{{ item.updated_by.name }} on {{ item.updated_at }}
            </ui-data-grid-item>
        </ui-data-grid>
    </ui-container>
</template>

<script>
import OperativePlanningOperativeBookingList from "./OperativePlanningOperativeBookingList";
import OperativePlanningOperativeBookingCard from "./OperativePlanningOperativeBookingCard";
import UiDataGridItem from "../ui/UiDataGridItem";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";

export default {
    components: {
        UiButtonNew,
        UiDataGrid, UiDataGridItem, OperativePlanningOperativeBookingCard, OperativePlanningOperativeBookingList
    },
    props: {
        packageId: null,
        item: Object,
        edit: Function,
        createItem: Function,
        removeItem: Function,
    },
    computed: {
        allRegisterOperatives() {
            return this.item.present.concat(this.item.absent).filter((operative) => !operative.was_booked);
        },
    },
    data() {
        return {}
    },
    methods: {
        openDeleteModal() {
            const title = 'Are you sure you want to delete this date\'s bookings and registers?'
            const description = 'Deleting this date will PERMANENTLY delete all bookings and register entries for it and is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
        duplicateItem() {
            this.createItem();
            this.$nextTick(() => {
                this.$root.$emit('item-duplicated', this.item);
            })
        }
    },
}
</script>
